import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Divider } from "antd";
import { CommonModal, RateComponent, Title, ButtonComponent, TextAreaComponent } from "@iiht/components";
import { myLabsPublic } from "../../constants/componentConstants";
import { requestUpdateRate } from "../../store/actions";
import { requestCreateCloudLabFeedback, requestUpdateCloudLabFeedback } from "../../store/actions/userMachineCatalog";
import { checkIfObjectNotEmpty } from "../../utils";
import "./useRateLabStyle.scss";

const useRateLab = (isDescription, publicCloudRateLab) => {
  const [rateModal, setRateModal] = useState(false);
  const [rateData, setRateData] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [rateRecord, setRateRecord] = useState({});
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleRate = (record) => {
    if (publicCloudRateLab?.labType) {
      publicCloudRateLab?.feedBack?.rating && setRateData(publicCloudRateLab?.feedBack?.rating);
      publicCloudRateLab?.feedBack?.feedback && setFeedback(publicCloudRateLab?.feedBack?.feedback);
      setRateModal(true);
    } else {
      setRateRecord(record);
      record?.rating && setRateData(record?.rating);
      setRateModal(true);
    }
  };

  const handleModalCancel = () => {
    setRateModal(false);
  };

  const hadleModalOk = () => {
    const data = {
      rating: rateData,
      feedback: feedback || null,
      cloud_template: publicCloudRateLab?.cloudTemplateId,
      cloud_lab: publicCloudRateLab?.cloudLabID,
    };
    if (publicCloudRateLab?.labType === myLabsPublic) {
      if (checkIfObjectNotEmpty(publicCloudRateLab?.feedBack)) {
        dispatch(requestUpdateCloudLabFeedback(data, publicCloudRateLab?.feedBack?.id));
        setRateModal(false);
        setRateData(0);
        setFeedback("");
      } else {
        dispatch(requestCreateCloudLabFeedback(data));
        setRateModal(false);
        setRateData(0);
        setFeedback("");
      }
    } else {
      setRateModal(false);
      const requestData = {
        rating: rateData,
      };
      dispatch(requestUpdateRate(requestData, rateRecord?.id));
      setRateData(0);
    }
  };

  const handleRateChange = (rate) => {
    setRateData(rate);
  };

  const feedbackChangeHandler = (e) => {
    setFeedback(e.target.value);
  };

  const rateLabDom = (
    <CommonModal visible={rateModal} handleCancel={handleModalCancel} closable className="rating-modal">
      <div className="modal-container">
        <Title className="title modal-title">{t("myLabs.Rate")}</Title>
        <div className="modal-body">
          <div className="rate-lab-container">
            <RateComponent onChange={handleRateChange} value={rateData} className="rate-star qa-rate-star" hiddenValue />
          </div>
          {isDescription && (
            <div className="modal-feedback mt3">
              <Title className="label-title">{t("myLabs.feedback")}</Title>
              <TextAreaComponent rows="3" placeholder="Write Feedback" value={feedback} onChange={feedbackChangeHandler} />
            </div>
          )}
        </div>
        <div className="rate-divider-wrapper">
          <Divider className="rate-hr" />
        </div>
        <div className="btn-wrapper">
          <ButtonComponent type="secondary" className="qa-rate-cancel-btn" onClick={handleModalCancel}>
            {t("common.remindLater")}
          </ButtonComponent>
          <ButtonComponent className="qa-rate-action-btn" onClick={hadleModalOk}>
            {t("common.submit")}
          </ButtonComponent>
        </div>
      </div>
    </CommonModal>
  );

  return { handleRate, rateLabDom };
};

export default useRateLab;
